export const categories = [
  {
    slug: 'dushi-yanqing',
    name: '都市言情',
    description: '繁华都市中的浪漫邂逅，丝袜美人的情感纠葛',
    icon: 'ri-building-2-line',
    color: 'accent',
  },
  {
    slug: 'qingchun-xiaoyuan',
    name: '青春校园',
    description: '青涩年华里的怦然心动，校园丝袜少女的成长故事',
    icon: 'ri-book-open-line',
    color: 'primary',
  },
  {
    slug: 'zhichang-qinggan',
    name: '职场情感',
    description: '职场精英的丝袜情缘，办公室里的暧昧与真心',
    icon: 'ri-briefcase-line',
    color: 'secondary',
  },
  {
    slug: 'gufeng-yanqing',
    name: '古风言情',
    description: '穿越时空的丝袜情愫，古韵与现代的完美交融',
    icon: 'ri-landscape-line',
    color: 'accent',
  },
  {
    slug: 'xuanyi-tuili',
    name: '悬疑推理',
    description: '丝袜背后的秘密，悬疑与情感交织的精彩故事',
    icon: 'ri-search-eye-line',
    color: 'primary',
  },
  {
    slug: 'xiandai-dushi',
    name: '现代都市',
    description: '当代都市中的丝袜佳人，快节奏生活里的温暖情缘',
    icon: 'ri-store-2-line',
    color: 'secondary',
  },
];